import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'
import ConnectMsgSuggestions from './ConnectMsgSuggestions'
import LexicoinCounter from '../dashboard_sections/LexicoinCounter'

class SendConnectRequest extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      otherUserId: '',
      text: '',
      sentNotification: false,
      error: '',
      buttonLoading: false
    }

    this.onClose = this.onClose.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.onSendRequest = this.onSendRequest.bind(this)
    this.selectPrompt = this.selectPrompt.bind(this)
  }

  handleChange(event) {
    this.setState({
      text: event.target.value,
      error: ''
    });
  }

  onSendRequest() {
    if(this.state.buttonLoading === true){
      return
    }
    this.setState({
      buttonLoading: true
    })
    if(this.state.text.length < 10) {
      this.setState({
        buttonLoading: false,
        error: `Please include a message to ${this.props.requestee_name}. Click a suggestion above for ideas.`
      })
      return
    } else {

      let data = {
        requestee_id: this.props.requestee_id,
        msg: this.state.text,
        og_connection: this.props.og_connection
      }

      $.ajax({
        url: `../requestConnection`,
        data: data,
        dataType: 'JSON',
        type: 'POST',
        header: {
          'Content-Type': 'application/json'
        },
        success: (data) => {
         this.props.updateOgConnectionNames ? this.props.updateOgConnectionNames(this.props.requestee_name) : null
         if(this.props.requestSent) {
           this.props.requestSent()
         }
         this.setState({
           buttonLoading: false,
           sentNotification: true
         })
        },
        error: function(xhr, status, err) {
          console.log(err)
        }.bind(this)
      });
    }
  }

  onClose() {
    this.props.closeRequest()
    this.setState({
      otherUserId: '',
      text: '',
      sentNotification: false
    })
  }

  selectPrompt(text) {
    this.setState({
      text: text
    })
  }

  render() {
    if(this.state.sentNotification) {
      return(
        <StandardModal  onClose={() => this.onClose()}>
            <h4 className="modalHeader">Request Sent!</h4>
            <h4 className="modalSubHeader">{this.props.requestee_name} has 7 days to respond.</h4>
            <h5 className="sectionText" style={{marginBottom: 10}}>When {this.props.requestee_name} accepts, we’ll alert you (turn on your notifications 🔊 ).</h5>
            <h5 className="sectionText">After {this.props.requestee_name} accepts, you can chat and start planning your Lex!</h5>
            <div className="modalSingleButtonSection" >
              <StandardButton text="Close" size="small" primary={true} onClick={() => this.onClose()} />
            </div>
        </StandardModal>
      )
    }
    return(
      <StandardModal
        onClose={() => this.onClose()}
        >
          <div style={{alignSelf: 'flex-end', display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
            {!this.props.pro &&
            <LexicoinCounter lexicoins={this.props.lexicoins}/>}
            {this.props.pro &&
              <h5 style={{backgroundColor: '#F48FB1', padding: 3, paddingRight: 10, paddingLeft: 10, borderRadius: 5, color: 'white', fontWeight: '700'}}>Pro</h5>
            }
          </div>
          <h3 style={{margin: 'auto', marginBottom: 10}}>Connect with {this.props.requestee_name}</h3>
          <ConnectMsgSuggestions
            selectPrompt={this.selectPrompt}
            requestee_name={this.props.requestee_name}
            />
          {this.state.error != '' &&
            <div style={{backgroundColor: '#FF7E47', borderRadius: 5, margin: 10, marginTop: 0}}>
              <h4 style={{color: 'white', padding: 5}}>{this.state.error}</h4>
            </div>}
          <textarea
            placeholder={`Introduce yourself to ${this.props.requestee_name}. Why are you learning a language, and what do you want to improve? When do you want to meet?`}
            type="text"
            className="textArea"
            value={this.state.text}
            onChange={this.handleChange}
          />
          <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: -45, marginBottom: 20, marginRight: 10}}>
            <StandardButton text="Send Request" size="small" primary={true} loading={this.state.buttonLoading} onClick={() => this.onSendRequest()} />
          </div>
          <div style={{display: 'flex', alignItems: 'left',justifyContent: 'center'}}>
            <h6 className="darkBlue">Sending a request costs 1 </h6>
            <div className="lexicoin" style={{height: 15, width: 15, marginRight: 6, backgroundSize: 'contain'}}/>

            <h6 className="premiumPink bold"> (Free for Pro members)</h6>
          </div>
          {(this.props.og_connection === true) && <div style={{display: 'flex', alignItems: 'center', marginTop: 24, justifyContent: 'center', textAlign: "center"}}>
            <h4 className="sectionText">You and {this.props.requestee_name} chatted, before Lexicoins, so this is free - and does not cost 1 <div className="lexicoin" style={{height: 25, width: 25, marginLeft: 3, backgroundSize: 'contain'}}/></h4>
          </div>}

      </StandardModal>
    )
  }
}

export default SendConnectRequest;
